import qr from '../../assets/images/qr.jpg'
import RegistrationFees from '../RegistrationFees/RegistrationFees'
import './Payments.css'
const Payments = () => {
    return (
        <div className="payments flex flex-col items-center justify-center gap-4 p-4">
            <div className="flex items-center justify-center gap-12 pt-8 flex-col md:flex-row">
                <div className="row  pcard first">
                    <div className="ptitle col-sm-12">
                        <i className="fa fa-university"></i>
                    </div>
                    <div className="col-sm-12 md:mt-[-3.5em] md:text-right text-center uppercase">Payment details</div>
                    <div className="flex justify-between md:px-24 mt-4 gap-[6rem]">
                        <div className="flex flex-col gap-[0.2rem]">
                            <div className="pinfo unknownBank col-sm-12">
                                <p className="ptitle">Account Name</p>
                                BNMIT IIT CEE
                            </div>
                            <div className="pinfo col-xs-6">
                                <p className="ptitle">Account Number</p>
                                <p>110089654784</p>
                            </div>
                            <div className="pinfo col-xs-6">
                                <p className="ptitle">IFSC Code</p>
                                <p>CNRB0001147</p>
                            </div>
                            <div className="pinfo col-xs-6">
                                <p className="ptitle">SWIFT Code</p>
                                <p>CNRBINBBBFD</p>
                            </div>
                        </div>
                        <div className="flex flex-col gap-[2.6rem]">
                            <div className="pinfo col-xs-6">
                                <p className="ptitle">Canara Bank</p>
                                <p>Banashankari II Stage<br /> Branch
                                    Bengaluru,<br /> State: Karnataka
                                    India.
                                </p>
                            </div>
                            <div className="pinfo col-xs-6">
                                <p className="ptitle">MICR Code</p>
                                <p>560015006</p>
                            </div>
                            
                        </div>
                    </div>
                    <div className="pfooter col-sm-12">
                        <div className="action reveal">
                            Verified
                        </div>
                    </div>
                </div>
                <img src={qr} alt="" className="w-[30rem]" />
            </div>
            <p className="font-bold">Payment details for IITCEE24</p>
            <RegistrationFees/>
        </div>

    )
}

export default Payments
